import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const PROMO_BANNER_COUNTDOWN_I18N_NAMESPACE =
  '@mc/promos/experiments/pen-7233_v1_promo_banner_countdown'

export const i18nInstance = registerI18nResources({
  namespace: PROMO_BANNER_COUNTDOWN_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
